import type { FaireProductEntity } from "../../entity_types/product";

export const p_2n25uzhftn: FaireProductEntity = {
  token: "p_2n25uzhftn",
  type: "product",
  name: "BANDANA PRINT A-LINE MIDI SKIRT - 7371S",
  brandToken: "b_8tg8mxotwp",
  brandName: "PINCH",
  imageUrl:
    "https://cdn.faire.com/fastly/78df249a3f8a14945e27256f42b0e4d9986e735fa995570c608aa48effb667ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56a7baaf47cf2f4c92b30ed724eb9778ef485e14825dc229615746fe455eab38.jpeg",
    "https://cdn.faire.com/fastly/65fe0b01a6f82f6ecd9d44b6ae8e07846e665144eeb4b99c1dbd71a87bfe2d96.jpeg",
    "https://cdn.faire.com/fastly/b3d3e95fc9e3d74cd298372942b6a665e268bce8109ac54a51438ade3dfb5d91.jpeg",
    "https://cdn.faire.com/fastly/0e1eb86305501bbef1480e041e94a7fa6429fe91281b3621dd54b3ef0dc2e679.jpeg",
    "https://cdn.faire.com/fastly/26d08cc56738ab11c7c6b1a714f0102361584d91e39f309cec1d54036804b899.jpeg",
    "https://cdn.faire.com/fastly/af25dff33aeb1d1c36aacd148aeb02b8f3ad118d378053443c5ba1da9d158a72.jpeg",
  ],
  priceDollars: 148.5,
  description:
    "BANDANA AND PAISLEY PRINT\nZIPPER AT SIDE\nHIGH-WAIST\nA-LINE\nMIDI LENGTH\nMATCHING TOP #7336W ,#7365T\n\nMODEL WEARS A SIZE SMALL",
  tags: [],
  msrpDollars: 297,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:50.957Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
